export enum DoiReqError {
  DoiNotIdentified,
  NoError,
}

export const errorCodes: { [key: string]: string } = {
  [DoiReqError.DoiNotIdentified]: 'Sorry, we could not identify this DOI.  ',
};
